import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function VerifyEmail() {
  const { verifyEmail, checkAuth } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("checking"); // checking | ok | error
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      if (!token) {
        setStatus("error");
        return;
      }
      try {
        await verifyEmail(token);
        await checkAuth();
        setStatus("ok");
      } catch {
        setStatus("error");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-8 text-center bg-background">
      {status === "checking" && (
        <>
          <Loader2 className="h-10 w-10 text-emerald-600 animate-spin mb-4" />
          <p className="text-slate-500" data-testid="verify-checking">
            Îți confirmăm emailul...
          </p>
        </>
      )}

      {status === "ok" && (
        <div data-testid="verify-success" className="flex flex-col items-center">
          <CheckCircle2 className="h-14 w-14 text-emerald-500 mb-4" />
          <h1 className="font-heading text-2xl font-black text-slate-900">
            Email confirmat!
          </h1>
          <p className="text-slate-500 text-sm mt-2">
            Îți mulțumim. Contul tău e acum verificat.
          </p>
          <button
            data-testid="verify-go-home"
            onClick={() => navigate("/", { replace: true })}
            className="mt-6 w-full max-w-xs h-12 rounded-2xl bg-emerald-600 text-white font-bold hover:bg-emerald-700 active:scale-95 transition-transform"
          >
            Continuă în aplicație
          </button>
        </div>
      )}

      {status === "error" && (
        <div data-testid="verify-error" className="flex flex-col items-center">
          <XCircle className="h-14 w-14 text-rose-500 mb-4" />
          <h1 className="font-heading text-2xl font-black text-slate-900">
            Link invalid sau expirat
          </h1>
          <p className="text-slate-500 text-sm mt-2 max-w-xs">
            Linkul de confirmare nu mai e valabil. Intră în cont și cere unul nou.
          </p>
          <button
            data-testid="verify-go-login"
            onClick={() => navigate("/login", { replace: true })}
            className="mt-6 w-full max-w-xs h-12 rounded-2xl bg-emerald-600 text-white font-bold hover:bg-emerald-700 active:scale-95 transition-transform"
          >
            Mergi la autentificare
          </button>
        </div>
      )}
    </div>
  );
}
